import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function LatestGuides() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="container-custom">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 mb-4">
            Latest Spreadsheet Guides
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            In-depth articles to help you master the AllChinaBuy spreadsheet and shop smarter
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/${article.slug}`}
              className="group flex flex-col bg-background-100 rounded-2xl overflow-hidden cursor-pointer transition-all hover:bg-background-200/60"
            >
              <div className="relative overflow-hidden" style={{ aspectRatio: "16/9" }}>
                <img
                  src={article.image}
                  alt={article.title}
                  className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 rounded-full bg-white/80 backdrop-blur-sm text-foreground-900 text-xs font-semibold whitespace-nowrap">
                    {article.tag}
                  </span>
                </div>
              </div>
              <div className="p-5 flex flex-col gap-2 flex-1">
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 leading-snug line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 flex-1">
                  {article.subtitle}
                </p>
                <div className="flex items-center justify-between mt-2 pt-3 border-t border-background-200">
                  <span className="text-xs text-foreground-500">
                    {article.dateModified}
                  </span>
                  <span className="text-xs font-medium text-primary-700 whitespace-nowrap">
                    Read more →
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}